/**
 * Stable CSS class names for E2E — Image search V2.
 */
export const IMGSEARCHV2 = {
    page: 'image-search-v2-page',
    breadcrumbSection: 'image-search-v2-page__breadcrumb-section',
    loadingSection: 'image-search-v2-page__loading-section',
    breadcrumbRow: 'image-search-v2-page__breadcrumb-row',
    searchTypeToggle: 'image-search-v2-page__search-type-toggle',

    downloadOverlayDialogPaper: 'image-search-v2-page__download-overlay-dialog',

    resultsToolbar: 'image-search-v2-page__results-toolbar',
    labelSelectAllWrap: 'image-search-v2-page__select-all-wrap',
    inputCheckboxSelectAll: 'image-search-v2-page-input--checkbox-select-all',
    inputIconListView: 'image-search-v2-page-input--icon-list-view',
    inputIconGridView: 'image-search-v2-page-input--icon-grid-view',
    downloadWrap: 'image-search-v2-page__download-wrap',

    resultsSummary: 'image-search-v2-page__results-summary',
    notFoundHint: 'image-search-v2-page__not-found-hint',

    gridImageList: 'image-search-v2-page__grid-image-list',
    gridImageListItem: 'image-search-v2-page__grid-image-item',
    gridImageOverlay: 'image-search-v2-page__grid-image-overlay',
    gridProductImage: 'image-search-v2-page__grid-product-image',
    inputCheckboxGridItem: 'image-search-v2-page-input--checkbox-grid-item',

    emptyStateWrap: 'image-search-v2-page__empty-state',
    searchPaperWrap: 'image-search-v2-page__search-paper-wrap',
    searchPaper: 'image-search-v2-page__search-paper',
    inputSearchCodes: 'image-search-v2-page-input--text-search-codes',
    inputButtonSearch: 'image-search-v2-page-input--button-search',
    batchSearchFormWrap: 'image-search-v2-page__batch-search-wrap',
    inputButtonBatchSearch: 'image-search-v2-page-input--button-batch-search',

    batchModalBody: 'image-search-v2-batch-modal__body',
    inputTextareaBatchCodes: 'image-search-v2-batch-modal-input--textarea-batch-codes',
    batchModalHintsRow: 'image-search-v2-batch-modal__hints-row',

    productListPaper: 'image-search-v2-product-list__paper',
    productListTable: 'image-search-v2-product-list__table',
    productRowCheckbox: 'image-search-v2-product-list-input--checkbox-row',
    productImageCell: 'image-search-v2-product-list__image-cell',
    productListPathCell: 'image-search-v2-product-list__path-cell',
    productListPathRibbon: 'image-search-v2-product-list__path-ribbon',

    imageThumbWrap: 'image-search-v2-thumb__wrap',
    imageThumbImage: 'image-search-v2-thumb__image',
    imageThumbMagnifyOverlay: 'image-search-v2-thumb__magnify-overlay',
    imageThumbMagnifyButton: 'image-search-v2-thumb__magnify-button',
} as const;

export const imgSearchV2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
